module.exports = __webpack_public_path__ + "img/bh2.0740ecb6.jpeg";